import React from 'react';
import { SelectionLevel, SelectionLevelProps } from '../../types/general';
import { Icon } from '../index';
import styles from '../SelectedCombination/selected-combination.module.css';

interface SelectionLabelProps {
    type: SelectionLevel;
}
const SelectionLabel = ({ type }: SelectionLabelProps) => {
    return (
        <>
            <div className={`${styles.label}  ${styles.alignMiddle}`}>
                <Icon icon={SelectionLevelProps[type]?.icon} /> <h6>{SelectionLevelProps[type]?.title}</h6>
            </div>
        </>
    );
};

export default SelectionLabel;
